import {
  ColdSubscription,
  listen,
  physics,
  pointer,
  tween,
  value,
  ValueReaction,
} from "popmotion";

import { HotSubscription } from "popmotion/lib/reactions/types";

interface RotationParameters {
  sensitivity: number;
}

const defaultRotationParameters: RotationParameters = {
  sensitivity: 0.2,
};

class Drag2Rotation {
  rotationParameters: RotationParameters = defaultRotationParameters;
  onAngleChange: (angle: number) => void;
  rotateValue: ValueReaction;
  private sub: HotSubscription;
  private sub1: ColdSubscription;
  private sub2: ColdSubscription;
  private pointerSub: ColdSubscription;
  private elt: HTMLElement;
  private mouseRotateMode: boolean;
  constructor(elt: HTMLElement) {
    this.elt = elt;
    this.rotateValue = value(0);
    this.mouseRotateMode = true;
    this.init();
  }
  setMouseRotateMode(active: boolean) {
    this.mouseRotateMode = active;
  }
  gotoAngle(angle: number) {
    tween({
      from: (this.rotateValue.get() as number) % 360,
      to: angle,
      duration: 1000,
    }).start(this.rotateValue);
  }
  rotate() {
    physics({
      from: (this.rotateValue.get() as number) % 360,
      velocity: 90,
      friction: 0.1,
      restSpeed: 10,
    }).start(this.rotateValue);
  }
  angleSubscriber(angle: number) {
    if (this.onAngleChange) {
      this.onAngleChange(angle);
    }
  }
  init() {
    const elt = this.elt;
    this.sub = this.rotateValue.subscribe(this.angleSubscriber.bind(this));
    this.sub1 = listen(elt, "mousedown touchstart")
      .filter((evt) => {
        const { touches } = evt;
        return this.mouseRotateMode && (!touches || touches.length < 2);
      })
      .start(() => {
        this.pointerSub = pointer({
          x:
            (this.rotateValue.get() as number) /
            this.rotationParameters.sensitivity,
        })
          .pipe(({ x }: any) => {
            return x * this.rotationParameters.sensitivity;
          })
          .start(this.rotateValue);
      });

    this.sub2 = listen(document, "pointerup").start(() => {
      this.pointerSub?.stop();
      physics({
        from: this.rotateValue.get(),
        velocity: this.rotateValue.getVelocity(),
        friction: 0.2,
        restSpeed: 10,
      }).start(this.rotateValue);
    });
  }
  unbind() {
    this.sub.unsubscribe();
    this.sub1.stop();
    this.sub2.stop();
    this.pointerSub.stop();
  }
}

export { Drag2Rotation };
